
define('template!webshopProductsListPositionView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="position">' +
((__t = ( position )) == null ? '' : __t) +
'</div>\n';

}
return __p
};});

